import { render, staticRenderFns } from "./AttachingTextItem.vue?vue&type=template&id=089c3c5d&scoped=true&"
import script from "./AttachingTextItem.vue?vue&type=script&lang=ts&"
export * from "./AttachingTextItem.vue?vue&type=script&lang=ts&"
import style0 from "./AttachingTextItem.vue?vue&type=style&index=0&id=089c3c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089c3c5d",
  null
  
)

export default component.exports